import { render, staticRenderFns } from "./EditSimple.vue?vue&type=template&id=55b05b06"
import script from "./EditSimple.vue?vue&type=script&lang=js"
export * from "./EditSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports